import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName, pickDataAttributes } from '../Util';

const ProgressSpinner = props => {
  const { classNames, color, containerClassName, pageLoader, size } = props;
  const dataAttributes = pickDataAttributes(props, 'progress-spinner');
  const styles = classNames || `preloader pl-${size} pls-${color}`;
  const containerStyles = containerClassName || (pageLoader ? 'page-loader' : 'preloader-container')

  if (typeof document !== 'undefined' && !pageLoader) {
    const body = document.querySelector('body');
    if (body.className.includes('loading')) {
      body.className = body.className.replace('loading', '');
    }
  }
  return (
    <div className={formatClassName([
      containerStyles,
      'd-print-none'
    ])}>
      <div className={styles} {...dataAttributes}>
        <svg className="pl-circular" viewBox="25 25 50 50">
          <circle className="plc-path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  )
}

ProgressSpinner.propTypes = {
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'lg',
    'xl',
    'xxl'
  ]),
  color: PropTypes.oneOf([
    'amber',
    'blue',
    'bluegray',
    'gray',
    'green',
    'pink',
    'purple',
    'red',
    'teal',
    'white',
    'yellow'
  ]),
  classNames: PropTypes.string,
  containerClassName: PropTypes.string,
  pageLoader: PropTypes.bool
}

ProgressSpinner.defaultProps = {
  color: 'primary',
  size: 'xl'
}

export default ProgressSpinner;
